export default{
    tarifas: [],
    tarifaSelec: null,
   
    tarifaMenosDe7: null,
    tarifaMasDe7: null,
    tarifaMenosDe7SinIVA: null, 
    tarifaMasDe7SinIVA: null, 
    tarifaMenosDe7Agencia: null, 
    tarifaMasDe7Agencia: null, 

    muscularMenosDe7: null,
    muscularMasDe7: null,
    muscularMenosDe7SinIVA: null, 
    muscularMasDe7SinIVA: null, 
    muscularMenosDe7Agencia: null, 
    muscularMasDe7Agencia: null, 

    tarifaMenosDe7SinIVAAgencia: null,
    tarifaMasDe7SinIVAAgencia: null,
    muscularMenosDe7SinIVAAgencia: null,
    muscularMasDe7SinIVAAgencia: null,

    tarifaSEUR: null,
    tarifaKm: null,
    tarifaFianza: null
}
